import { render } from "./PaginationControlsComp.vue?vue&type=template&id=da739348"
import script from "./PaginationControlsComp.vue?vue&type=script&lang=js"
export * from "./PaginationControlsComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__